import icon1 from '../assets/images/service/ser1.png'
import icon2 from '../assets/images/service/ser2.png'
import icon3 from '../assets/images/service/ser3.png'



const sematServices = [
    {
        Id: '2',
        sTitle: 'PLAN DE PROTECTION MANITOU GROUP PARTS™ EXTENSION DE GARANTIE',
        description: 'La marque GEHL fait partie du groupe Manitou, leader dans la fabrication de solutions de manutention. Aussi, Manitou Group Finance vous propose la solution de financement la mieux adaptée à vos besoins et aux spécificités de votre activité pour votre équipement GEHL.',
        des2: 'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3: 'Le plan de protection Manitou Group Parts™ est une option de couverture exclusive disponible sur tous les nouveaux produits de marque GEHL jusqu\'à cinq ans ou 6 000 heures. Le financement de ce plan est disponible lors de l\'achat initial de l\'équipement et couvre le coût des pièces et de la main-d\'œuvre.',
        icon: icon1,
    },
    {
        Id: '1',
        sTitle: 'PIÈCES DE RECHANGE DU GROUPE MANITOU',
        description: 'Utilisation de piece d\'origines pour optimiser les performances de vos machines GEHL propose aux professionnels qui utilisent ses machines un service de remplacement de pièces. Grâce à notre expérience en tant que constructeur, les techniciens qui interviennent sur votre site ou en atelier pour réparer et entretenir vos engins sont en mesure de changer vos pièces détachées avec des éléments conformes aux standards d’origine GEHL.',
        des2: 'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3: 'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon: icon2,
    },
    {
        Id: '3',
        sTitle: 'PLAN DE PROTECTION DES ÉQUIPEMENTS GARANTIE STANDARD',
        description: 'Saviez-vous que votre machine peut être garantie jusqu\'à 6 ans et/ou 6 000 heures ? Afin de respecter vos besoins, vous disposez de deux niveaux de garantie. XPRT™ Protection Plan vous assure une protection efficiente !',
        des2: 'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3: 'Nous soutenons nos produits - pur et simple. Nous comprenons également la charge de travail qu\'ils gèrent jour après jour. C\'est pourquoi chaque machine est livrée avec une garantie standard de deux ans ou de 2 000 heures selon ce que vous conquérez en premier.',
        icon: icon3,
    }
]
export default sematServices;